export enum ObjectState {
    Unknown = 0, New = 1, Updated = 2, Deleted = 3
}